type RuntimeEnv = Record<string, string | undefined>;

const viteEnv = (import.meta as any).env as RuntimeEnv | undefined;
const nodeEnv: RuntimeEnv | undefined =
  typeof process !== "undefined" ? (process.env as RuntimeEnv) : undefined;

const getEnv = (key: string): string | undefined => viteEnv?.[key] ?? nodeEnv?.[key];

export const STRIPE_CONFIG = {
  publishableKey: getEnv("VITE_STRIPE_PUBLISHABLE_KEY"),
  enabled: !!getEnv("VITE_STRIPE_PUBLISHABLE_KEY"),
};

export const APP_CONFIG = {
  name: "WIH Media",
  url: getEnv("VITE_APP_URL") || "http://localhost:5173",
  supportEmail: "support@wihmedia.com",
  taxRate: 0, // Tax disabled (digital delivery)
};

export const ROUTES = {
  HOME: "/",
  SERVICES: "/services",
  PORTFOLIO: "/portfolio",
  PROPERTIES_MAP: "/properties/map",
  FAQ: "/faq",
  SHOWROOM: "/showroom",
  SHOWROOM_PROJECT: "/showroom/:projectId",
  CONTACT: "/contact",
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/auth/forgot-password",
  RESET_PASSWORD: "/auth/reset-password",
  EMAIL_CONFIRM: "/auth/confirm",
  BOOKING: "/booking",
  CART: "/cart",
  CHECKOUT: "/checkout",
  SERVICE_AGREEMENT: "/service-agreement",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
  COOKIE_POLICY: "/cookie-policy",
  EMAIL_PREFERENCES: "/email-preferences",

  // Customer routes
  CUSTOMER_DASHBOARD: "/dashboard",
  CUSTOMER_BOOKINGS: "/dashboard/bookings",
  CUSTOMER_INVOICES: "/dashboard/invoices",
  CUSTOMER_DELIVERABLES: "/dashboard/deliverables",
  CUSTOMER_PROFILE: "/dashboard/profile",

  // Admin routes
  ADMIN_DASHBOARD: "/admin",
  ADMIN_ANALYTICS: "/admin/analytics",
  ADMIN_PENDING_APPROVALS: "/admin/pending-approvals",
  ADMIN_CATALOG: "/admin/catalog",
  ADMIN_BOOKINGS: "/admin/bookings",
  ADMIN_BOOKING_SETTINGS: "/admin/booking-settings",
  ADMIN_EMAIL_SETTINGS: "/admin/email-settings",
  ADMIN_INVOICES: "/admin/invoices",
  ADMIN_PACKAGES: "/admin/packages",
  ADMIN_SERVICES: "/admin/services",
  ADMIN_PORTFOLIO: "/admin/portfolio",
  ADMIN_SHOWROOM: "/admin/showroom",
  ADMIN_SHOWROOM_DEMO: "/admin/showroom-demo",
  ADMIN_TESTIMONIALS: "/admin/testimonials",
  ADMIN_REVIEWS: "/admin/reviews",
  ADMIN_COUPONS: "/admin/coupons",
  ADMIN_DELIVERABLES: "/admin/deliverables",
};

export const SUPABASE_TABLES = {
  USERS: "users",
  SERVICES: "services",
  PACKAGES: "packages",
  ADDONS: "addons",
  BOOKINGS: "bookings",
  REVIEWS: "reviews",
  SHOWROOM_PROJECTS: "showroom_projects",
};

export const STORAGE_PATHS = {
  PORTFOLIO: "portfolio",
  DELIVERABLES: "deliverables",
  INVOICES: "invoices",
  THUMBNAILS: "thumbnails",
  PROFILES: "profiles",
};

export const DATE_FORMAT = "MMM dd, yyyy";
export const TIME_FORMAT = "h:mm a";
export const DATETIME_FORMAT = "MMM dd, yyyy h:mm a";

export const PROPERTY_TYPES = [
  "Residential House",
  "Apartment/Condo",
  "Commercial Property",
  "Land/Lot",
  "Luxury Estate",
  "Multi-family",
  "Other",
];

export const BOOKING_TIME_SLOTS = [
  "8:00 AM",
  "9:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "1:00 PM",
  "2:00 PM",
  "3:00 PM",
  "4:00 PM",
  "5:00 PM",
  "6:00 PM",
];
